import { useEffect, useRef, useState } from 'react';
import ToolbarButton from '../ToolbarButton';
import styles from './styles.module.scss';

/**
 * @todo handle the popups to avoid get them outside the viewport
 */
export default function ToolbarButtonWithDropdown({
  style,
  children,
  disabled,
  dropdownComponent,
  'aria-label': ariaLabel,
  'data-active': dataActive,
}) {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const pickerRef = useRef(null);

  useEffect(() => {
    function handleClickOutsidePicker(event) {
      if (pickerRef.current && !pickerRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutsidePicker);
    return () => {
      document.removeEventListener('mousedown', handleClickOutsidePicker);
    };
  }, []);

  const handleOpenDropdown = () => {
    setIsDropdownOpen(true);
  };

  return (
    <div className={styles.container}>
      <ToolbarButton
        className={styles.button}
        onClick={handleOpenDropdown}
        disabled={disabled}
        data-active={dataActive}
        aria-label={ariaLabel}
      >
        {children}
        <span className={styles.chevron}>▼</span>
      </ToolbarButton>

      {isDropdownOpen && (
        <div
          className={styles['dropdown-wrapper']}
          style={style}
          ref={pickerRef}
        >
          {dropdownComponent}
        </div>
      )}
    </div>
  );
}
